// A supplier-portal session calls the portal copy of a shared endpoint, served at the same path under the
// `/supplier-portal` prefix of the same service.
export const supplierPortalPath = <Path extends `/${string}`>(path: Path, isSupplier: boolean) =>
  isSupplier ? (`/supplier-portal${path}` as const) : path
